<template>
    <section class="inline large">
        <div class="grid xs-grid-cols-1 gap-3 fixed fixed-max-sm">
            <div class="flex left">
                <b class="f3 text-capitalize">{{data.title}}</b>
                <a :href="glb.appUrl+'schools/'" class="btn secondary regular">Change location</a>
            </div>
        </div>
    </section>
    <template v-if="data.dataList && data.dataList.length">
        <section class="inline large"  v-for="(list, index) in data.dataList">
            <mvtListLinks :title="list.title" :links="list.data" :key="index" />
        </section>
    </template>
    <section class="inline large">
        <div class="grid xs-grid-cols-1 gap-3 fixed fixed-max-sm">
            <div class="flex center" v-html="data.paginationHTML"></div>
            <div>
                <a class="link" :href="glb.appUrl+data.stateInfo.nameForUrl+'/schools/'">Browse Schools By City in {{data.stateName}}</a>
            </div>
            <div class="schools-info-para">
                This is a list of school districts in {{data.stateName}}. Each of the school districts links will take you to a page with a list of schools in the school district. Movoto provides real estate brokerage services staffed with experienced real estate agents to help you find and buy your home.
            </div>
        </div>
    </section>
</template>

<script src="./schools-districtstate.js"></script>

